module.exports = __webpack_public_path__ + "img/bg-image-19.a1532d1e.jpg";